import { Modal } from 'almanac-ui/Modal'
import { ConfirmDeleteMediaFileModalProps } from './Types'
import { Button } from 'components/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const ConfirmDeleteMediaFileModal = ({
  onConfirm,
  title,
  type,
  close,
  isProcessing,
}: ConfirmDeleteMediaFileModalProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Modal.Root>
      <Modal.Header title={`Delete this ${type ? `${type} file` : 'file'}?`} />
      <Modal.Content>Are you sure you want to delete {title}?</Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size={isMobile ? 'xl' : 'lg'} variant="tertiary" onPress={close}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size={isMobile ? 'xl' : 'lg'} onPress={onConfirm} isDisabled={isProcessing}>
            Confirm
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { ConfirmDeleteMediaFileModal }
